/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-12 14:26:48
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-06-07 16:04:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/tools.ts
 * @LastEditTime: 2021-03-24 13:03:41
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/tools.ts
 */

import { randomNumber } from '@/src/tools/helper';
import _ from 'lodash';
import {
  generateBody,
  initContentBody,
  initContentError,
} from 'src/constrains/DraggableModules/tools';
import { isInPCorNative } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { validateFloatingActionsBar } from 'src/pages/SalesChannelContentEditor/Components/FloatingActionsBar/tools';
import { EnumCollapseId } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/common';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
import { EnumContentPageStatus } from 'src/types/common/SalesChannel';

const convertDataFromServerToRedux = (data, isPrimary) => {
  //const { hasErrorCollapse } = queries || {};
  //console.log(data);
  const {
    contentBody = [],
    contentUuid,
    salesChannelContent,
    salesChannelName,
    seoSetting,
    iconStyle,
    uuid,
    modifiedDate,
    createdDate,
    floatingBar,
    miniProgramShare,
    miniProgramPageInfo,
    breakpoint,
    siteStyle,
    contentPages,
    translationEnabled = false,
    //hasError: hasErrorCollapse,
  } = data;
  const _isInPC = isInPCorNative(siteStyle, breakpoint);

  const isNew = modifiedDate === createdDate;

  const moduleContentOrder = [];
  const moduleContentStaticConfig = {};
  const moduleContentDynamicConfig = {};
  const collapseOpen = {
    [EnumCollapseId.iconStyle]: false,
    [EnumCollapseId.seoSetting]: false,
    [EnumCollapseId.floatingBar]: false,
    [EnumCollapseId.miniProgramShare]: false,
    [EnumCollapseId.miniProgramPageInfo]: false,
  };
  const collapseErrorMsgDisplay = {
    [EnumCollapseId.iconStyle]: { hasError: false, display: !isNew },
    [EnumCollapseId.seoSetting]: { hasError: false, display: !isNew },
    [EnumCollapseId.floatingBar]: { hasError: false, display: !isNew },
    [EnumCollapseId.miniProgramShare]: { hasError: false, display: !isNew },
    [EnumCollapseId.miniProgramPageInfo]: { hasError: false, display: !isNew },
  };
  const _iconStyle = {
    colour: '#000000',
  };
  const _seoSetting = { title: '', description: '', favicon: null };
  //console.log('collapseErrorMsgDisplay', collapseErrorMsgDisplay);

  initContentBody({
    contentBody,
    moduleContentOrder,
    isNew,
    collapseOpen,
    collapseErrorMsgDisplay,
    moduleContentDynamicConfig,
    moduleContentStaticConfig,
  });

  const _a = {
    miniProgramShare: miniProgramShare || {},
    miniProgramPageInfo: miniProgramPageInfo || {},
    moduleContentOrder,
    moduleContentStaticConfig,
    moduleContentDynamicConfig,
    collapseOpen,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    seoSetting: seoSetting || _seoSetting,
    iconStyle: iconStyle || _iconStyle,
    uuid,
    translationEnabled,
    collapseErrorMsgDisplay,
    floatingBar: Object.assign({}, floatingBar || {}, {
      buttons: ((floatingBar || {}).buttons || []).map((b) => ({
        draggableId: randomNumber(),
        ...b,
      })),
    }),
    ...reduxUpdatedStatusControl,
  };
  if (!isNew) {
    let flag = false;
    if (_isInPC) {
      const seoErr = validateSeoSetting(_a.seoSetting);
      if (seoErr.length > 0) {
        _a.collapseOpen[EnumCollapseId.seoSetting] = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].hasError = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].display = true;
        flag = true;
        return _a;
      }
    } else {
      const seoErr = validateSeoSetting(_a.seoSetting);
      if (seoErr.length > 0) {
        _a.collapseOpen[EnumCollapseId.seoSetting] = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].hasError = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].display = true;
        flag = true;
        return _a;
      }
      const { hasError: floatingBarHasError } = validateFloatingActionsBar(
        _a.floatingBar,
        isPrimary,
      );
      if (floatingBarHasError) {
        _a.collapseOpen[EnumCollapseId.floatingBar] = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.floatingBar].hasError = true;
        _a.collapseErrorMsgDisplay[EnumCollapseId.floatingBar].display = true;
        flag = true;
      }
    }

    const inUsePages = (contentPages || []).filter(
      (p) => p.status === EnumContentPageStatus.InUse,
    );

    initContentError({
      flag,
      moduleContentDynamicConfig,
      _a,
      moduleContentOrder,
      moduleContentStaticConfig,
      validationProps: { breakpoint, siteStyle, contentPages: inUsePages },
    });
  }

  return _a;
};

const convertDataFromReduxToServer = (state, validationProps?) => {
  const _state = _.cloneDeep(state);

  const {
    moduleContentOrder,
    moduleContentStaticConfig,
    moduleContentDynamicConfig,
    iconStyle,
    seoSetting,
    contentUuid,
    uuid,
    floatingBar,
    miniProgramShare,
    miniProgramPageInfo,
  } = _state;

  const _body = generateBody({
    moduleContentDynamicConfig,
    moduleContentOrder,
    moduleContentStaticConfig,
    validationProps,
  });

  return {
    iconStyle,
    seoSetting,
    contentUuid,
    contentBody: _body,
    uuid,
    floatingBar,
    miniProgramShare,
    miniProgramPageInfo,
  };
};

const validateSeoSetting = (seoSetting) => {
  const err = [];

  return err;
};

// const validateFloatingActionsBar = (floatingActionsBar) => {
//   const { buttons = [] } = floatingActionsBar;
//   const generalError = [];

//   const specificError = buttons.reduce((a, b) => {
//     a[b['draggableId'] + 'buttonsErr'] = [];
//     return a;
//   }, {});

//   let hasError = false;

//   for (let i = 0; i < buttons.length; i++) {
//     const b = buttons[i];

//     if (!b.name || !b.icon || !b.linkModule) {
//       hasError = true;
//       specificError[b['draggableId'] + 'buttonsErr'].push(
//         'Link and icon cannot be empty.',
//       );
//     }
//   }

//   return {
//     hasError,
//     specificError,
//     generalError,
//   };
// };

export {
  convertDataFromReduxToServer,
  convertDataFromServerToRedux,
  validateSeoSetting,
  validateFloatingActionsBar,
};
